import {toUrlCleanString} from "@/utility/data/url"
import OrganizationDefaultContent from "@/managers/data/organization/organizationDefaultContent"

export default class SingleStoreRequest {
	public key: string

	public name: string
	public language: string
	public phone: string
	public industry: number
	public timezone: string
	public currency: string

	public isDealsEnabled: boolean
	public isLiveEnabled: boolean

	public defaultContent: OrganizationDefaultContent | null

	constructor(name: string, language: string, phone: string, industry: number, timezone: string, currency: string, isDealsEnabled: boolean, isLiveEnabled: boolean, defaultContent: OrganizationDefaultContent | null = null) {
		this.key = toUrlCleanString(name)
		this.name = name
		this.language = language
		this.phone = phone
		this.industry = industry
		this.timezone = timezone
		this.currency = currency
		this.isDealsEnabled = isDealsEnabled
		this.isLiveEnabled = isLiveEnabled
		this.defaultContent = defaultContent
	}

	public toJSON(): string {
		return JSON.stringify(
			{
				key: this.key,
				name: this.name,
				language: this.language,
				phone: this.phone,
				industry: this.industry,
				timezone: this.timezone,
				currency: this.currency,
				isDealsEnabled: this.isDealsEnabled,
				isLiveEnabled: this.isLiveEnabled,
				defaultContent: this.defaultContent
			}
		)
	}

	public static fromJSON(data: string): SingleStoreRequest {
		const dataObject = JSON.parse(data)

		return new SingleStoreRequest(
			dataObject.name,
			dataObject.language,
			dataObject.phone,
			dataObject.industry,
			dataObject.timezone,
			dataObject.currency,
			dataObject.isDealsEnabled,
			dataObject.isLiveEnabled,
			dataObject.defaultContent
		)
	}
}

export {OrganizationDefaultContent}
